import React from "react";
import MerchantLayout from "../../../layouts/merchant/merchant_layout";
import MerchantVoucherRedemption from "../components/merchant_voucher_redemption/merchant_voucher_redemption";

export default function VoucherRedemption() {
  return (
    <MerchantLayout>
      <MerchantVoucherRedemption />
    </MerchantLayout>
  );
}
